<template>
    <div class="content-grid">
        <div class="content-grid__header">
            <h1 class="back-link-title">{{ t(`routes.activities.name`) }}</h1>
        </div>
        <MemberActivities/>
    </div>
</template>


<script lang="ts" setup>
import MemberActivities from '@/components/members/MemberActivities.vue';

import {useI18n} from "vue3-i18n";

const {t} = useI18n()
</script>